import { firebaseIdToken } from "./firebase-client";

declare global {
  interface Window {
    __ASYMMETRIC_API_ORIGIN__?: string;
    __ASYMMETRIC_ENVIRONMENT__?: "development" | "test" | "production";
  }
}

function configuredApiOrigin() {
  if (typeof window === "undefined") return "";
  return window.__ASYMMETRIC_API_ORIGIN__?.replace(/\/$/, "") ?? "";
}

function addLocalTestIdentity(headers: Headers) {
  if (typeof window === "undefined" || window.__ASYMMETRIC_ENVIRONMENT__ !== "test") return;
  headers.set("oai-authenticated-actor-kind", "owner");
  headers.set("oai-authenticated-user-id", "local-test-owner");
  headers.set("oai-authenticated-user-email", "test@local.asymmetric");
}

export async function apiFetch(input: RequestInfo | URL, init: RequestInit = {}) {
  // A stalled read must release loading controls and allow the workspace to retry.
  if (!init.signal && (init.method ?? "GET").toUpperCase() === "GET") {
    init = { ...init, signal: AbortSignal.timeout(30_000) };
  }
  const apiOrigin = configuredApiOrigin();
  const headers = new Headers(init.headers);
  if (!apiOrigin) {
    addLocalTestIdentity(headers);
    return fetch(input, { ...init, headers });
  }

  const token = await firebaseIdToken();
  headers.set("authorization", `Bearer ${token}`);

  let target: RequestInfo | URL = input;
  if (typeof input === "string" && input.startsWith("/")) {
    target = `${apiOrigin}${input}`;
  } else if (input instanceof URL && input.origin === window.location.origin) {
    target = new URL(`${input.pathname}${input.search}`, apiOrigin);
  }

  return fetch(target, { ...init, headers });
}
